var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initials-avatar"},[_c('b-avatar',_vm._b({staticClass:"user-select-none",attrs:{"text":_vm.text,"variant":_vm.variant,"title":_vm.title}},'b-avatar',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }